import { setGA4UserProperties } from './ga4';
import { identifyPostHogUser } from './posthog';

/**
 * Identifies user across all analytics providers (GA4 + PostHog).
 * Single call replaces separate setGA4UserProperties + identifyPostHogUser calls.
 * @param {Object} options - Same shape as identifyPostHogUser / setGA4UserProperties
 * @param {Object} options.agency - Agency object
 * @param {Object} options.agent - Agent object
 * @param {Object} options.client - Client object
 * @param {string} options.userType - 'agent' or 'client'
 */
export const identifyAnalyticsUser = ({ agency, agent, client, userType }) => {
  setGA4UserProperties({ agency, agent, client, userType });
  identifyPostHogUser({ agency, agent, client, userType });
};
